import React from 'react'

import { Icon } from '@st-operations/uikit/src/v2'
import IconPencil from '_icons/IconPencil'

const CategoryBox = ({ item, handleClearCat, targetsRef, handleDialog }) => {
  const formatSelectedValues = () => {
    const checked = item.values.filter((value) => value.check)
    if (item?.category?.name?.startsWith?.('predictor_')) {
      return checked
        .map((value) => {
          const top = Math.max(0, Math.min(100, 100 - (Number(value?.percentile ?? 0))))
          return `${value.label} (top ${top}%)`
        })
        .join(', ')
    }
    return checked.map((value) => value.label).join(', ')
  }
  const selectedValues = formatSelectedValues()

  return (
    <div
      className="filters__item"
      ref={(el) => {
        targetsRef.current[item.category.name] = el
      }}
    >
      <button onClick={handleDialog(item.category.name)}>
        <IconPencil fill="#222" size="14px" />
        <span>
          <b>{item.category.label}:</b> {selectedValues}
        </span>
      </button>
      <button className="filters__clear" onClick={handleClearCat(item.category.name)}>
        <Icon type="fill" icon="delete" color="#777777" width="14px" height="14px" />
      </button>
    </div>
  )
}

export default CategoryBox
